import utilsFunctions from './utilsFunctions'
 
var useUtils = () => {
    return utilsFunctions()
}
export default useUtils;
